import { useId } from "react";

import { cn } from "@/lib/utils";

export function ExperiencesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[74px] w-[118px]", className)}
      fill="none"
      viewBox="0 0 118 74"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.227 37.862v-2.386L59.18 24.85l55.264 31.994v2.93l-39.042 13.23-55.174-35.141z"
        fill={`url(#${id}-a)`}
      />
      <path
        d="M20.227 35.477l38.952-13.559 55.264 34.925-39.108 13.302-55.108-34.668z"
        fill={`url(#${id}-b)`}
      />
      <path
        clipRule="evenodd"
        d="M29.168 39.207c-.31-.244-.775-.371-1.363-.23-1.237.297-2.278 1.617-2.278 2.89 0 .605.232 1.027.542 1.271.31.244.775.372 1.363.23.41-.098.44-.085.795-.392l1.5 1c-.523.454-1.23.782-1.922.948-1.009.243-1.99.052-2.727-.53-.737-.58-1.151-1.49-1.151-2.527 0-2.012 1.548-3.976 3.505-4.446 1.009-.242 1.99-.051 2.726.53.542.427.91 1.031 1.066 1.733.097.432-.272.794-.714.794-.442 0-.772-.377-.958-.777a1.34 1.34 0 00-.384-.494zm9.8 6.158c-.31-.244-.775-.371-1.363-.23-1.237.297-2.278 1.617-2.278 2.89 0 .605.232 1.027.542 1.271.31.244.775.372 1.362.23.411-.098.441-.085.795-.392l1.5 1c-.522.454-1.23.783-1.921.949-1.01.242-1.99.05-2.727-.53-.737-.581-1.151-1.49-1.151-2.528 0-2.012 1.548-3.976 3.504-4.446 1.01-.242 1.99-.051 2.727.53.542.427.91 1.031 1.066 1.734.096.43-.272.794-.714.794-.442 0-.773-.377-.958-.778a1.34 1.34 0 00-.384-.494zm9.799 6.158c-.31-.244-.774-.372-1.362-.23-1.238.296-2.279 1.617-2.279 2.89 0 .604.233 1.026.543 1.27.31.244.774.372 1.362.231.411-.099.441-.085.795-.392l1.5 1c-.522.453-1.23.782-1.921.948-1.01.242-1.99.051-2.727-.53-.737-.581-1.152-1.49-1.152-2.528 0-2.012 1.549-3.976 3.505-4.446 1.01-.242 1.99-.05 2.727.53.542.427.91 1.032 1.066 1.734.096.431-.273.794-.714.794-.442 0-.773-.377-.959-.778a1.34 1.34 0 00-.384-.493zm9.8 6.157c-.31-.243-.775-.37-1.362-.23-1.238.297-2.279 1.618-2.279 2.89 0 .605.233 1.028.542 1.272.31.244.775.371 1.363.23.411-.099.441-.085.795-.392l1.5 1c-.523.453-1.23.782-1.921.948-1.01.242-1.99.051-2.727-.53-.737-.58-1.152-1.49-1.152-2.528 0-2.012 1.548-3.976 3.505-4.445 1.01-.243 1.99-.052 2.727.53a3 3 0 011.066 1.733c.096.431-.273.794-.715.794-.441 0-.772-.377-.958-.778a1.34 1.34 0 00-.384-.493zm9.8 6.158c-.31-.244-.775-.372-1.363-.23-1.237.297-2.278 1.617-2.278 2.89 0 .604.233 1.027.542 1.27.31.245.775.373 1.363.231.41-.098.44-.085.795-.392l1.5 1c-.523.454-1.23.782-1.922.948-1.009.242-1.99.051-2.726-.53-.737-.58-1.152-1.49-1.152-2.527 0-2.013 1.548-3.977 3.505-4.446 1.009-.242 1.99-.051 2.727.53a3.017 3.017 0 011.066 1.733c.096.432-.273.794-.715.794-.442 0-.772-.377-.958-.778a1.34 1.34 0 00-.384-.493z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M3.412 37.663v-2.386L42.366 24.65 97.63 56.643v2.931l-39.042 13.23L3.412 37.663z"
        fill={`url(#${id}-c)`}
      />
      <path
        d="M3.413 35.277L42.365 21.72 97.63 56.644 58.522 69.946 3.413 35.277z"
        fill={`url(#${id}-d)`}
      />
      <path
        d="M76.67 60.804l13.366-4.966c1.54-.572 1.772-2.653.396-3.55L70.715 39.43a12 12 0 00-10.695-1.212l-14.278 5.248c-1.57.576-1.78 2.71-.353 3.583L66.23 59.793a12 12 0 0010.439 1.01z"
        fill={`url(#${id}-e)`}
        opacity="0.3"
      />
      <path
        clipRule="evenodd"
        d="M12.354 39.008c-.31-.244-.774-.372-1.362-.23-1.238.297-2.279 1.617-2.279 2.89 0 .604.233 1.027.543 1.27.309.245.774.372 1.362.231.411-.098.441-.085.795-.392l1.5 1c-.523.453-1.23.782-1.921.948-1.01.242-1.99.051-2.727-.53-.737-.58-1.152-1.49-1.152-2.527 0-2.013 1.548-3.977 3.505-4.446 1.01-.242 1.99-.052 2.727.53.542.427.91 1.03 1.066 1.733.096.431-.273.794-.714.794-.442 0-.773-.377-.959-.778a1.339 1.339 0 00-.384-.493zm9.8 6.158c-.31-.244-.774-.371-1.363-.23-1.237.297-2.278 1.617-2.278 2.89 0 .605.233 1.027.542 1.271.31.244.775.372 1.363.23.41-.098.441-.085.795-.392l1.5 1c-.523.454-1.23.782-1.922.948-1.009.243-1.99.052-2.726-.53-.737-.58-1.152-1.49-1.152-2.527 0-2.012 1.548-3.976 3.505-4.446 1.009-.242 1.99-.051 2.727.53a3.01 3.01 0 011.066 1.734c.096.43-.273.793-.715.793-.441 0-.772-.377-.958-.777a1.34 1.34 0 00-.384-.494zm9.8 6.158c-.31-.244-.775-.371-1.363-.23-1.237.297-2.278 1.617-2.278 2.89 0 .605.233 1.027.542 1.271.31.244.775.372 1.363.23.41-.098.44-.084.795-.392l1.5 1c-.523.454-1.23.783-1.922.948-1.009.243-1.99.052-2.726-.53-.737-.58-1.152-1.49-1.152-2.527 0-2.012 1.548-3.976 3.505-4.446 1.009-.242 1.99-.051 2.726.53.542.427.91 1.031 1.067 1.734.096.43-.273.794-.715.794-.442 0-.772-.377-.958-.778a1.34 1.34 0 00-.384-.494zm9.8 6.158c-.31-.244-.775-.372-1.363-.23-1.237.296-2.278 1.617-2.278 2.89 0 .604.232 1.026.542 1.27.31.245.775.372 1.363.23.41-.098.44-.084.794-.391l1.5 1c-.522.453-1.23.782-1.92.948-1.01.242-1.99.051-2.728-.53-.737-.581-1.151-1.49-1.151-2.528 0-2.012 1.548-3.976 3.505-4.446 1.009-.242 1.99-.051 2.726.53.542.427.91 1.032 1.066 1.734.097.431-.272.794-.714.794-.442 0-.772-.377-.958-.778a1.34 1.34 0 00-.384-.493zm9.8 6.158c-.31-.244-.775-.372-1.363-.23-1.237.296-2.279 1.617-2.279 2.89 0 .604.233 1.027.543 1.27.31.245.774.372 1.362.231.411-.099.441-.085.795-.392l1.5 1c-.522.453-1.23.782-1.921.948-1.01.242-1.99.051-2.727-.53-.737-.58-1.151-1.49-1.151-2.528 0-2.012 1.548-3.976 3.504-4.446 1.01-.242 1.99-.05 2.727.53.542.427.91 1.032 1.066 1.734.096.431-.272.794-.714.794-.442 0-.773-.377-.959-.778a1.34 1.34 0 00-.383-.493z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M42.727 29.477l-19 7 9 5 18.5-7-8.5-5z"
        fill="#fff"
        opacity="0.5"
      />
      <path
        d="M48.573 5.83c-.158-.624-.287-1.282-.088-1.894C49.634.41 57.113-.43 60.505 1.649l18.223 11.167c3.68 2.255 6.663 7.581 6.663 11.897v21.372c0 4.074-6.32 7.218-10.123 5.66-.448-.183-.83-.491-1.188-.816L61.044 39.137a12.905 12.905 0 00-1.144-.89c-3.131-2.25-5.638-6.658-6.01-10.527-.061-.64-.127-1.283-.284-1.907L48.573 5.83z"
        fill="#ADEAFF"
      />
      <path
        d="M47.54 6.692c0-4.315 2.983-5.986 6.662-3.73l18.223 11.166c3.68 2.255 6.663 7.581 6.663 11.897v21.372c0 4.316-2.983 5.986-6.663 3.731L54.202 39.961c-3.68-2.255-6.662-7.58-6.662-11.896V6.692z"
        fill={`url(#${id}-f)`}
      />
      <path
        clipRule="evenodd"
        d="M74.463 25.518l-15.851 7.95-6.136-10.42 2.093-1.281 4.141 7.03 13.765-7.03 1.988 3.751z"
        fill="#fff"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-a`}
          x1="166.689"
          x2="27.316"
          y1="32.387"
          y2="66.029"
        >
          <stop stopColor="#FFD574" />
          <stop offset="1" stopColor="#E0B45D" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="41.428"
          x2="65.234"
          y1="47.584"
          y2="16.698"
        >
          <stop stopColor="#C06B12" />
          <stop offset="1" stopColor="#F7B214" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-c`}
          x1="149.874"
          x2="10.501"
          y1="32.188"
          y2="65.83"
        >
          <stop stopColor="#CEA8FF" />
          <stop offset="1" stopColor="#8F5DE0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-d`}
          x1="112.218"
          x2="-2.198"
          y1="-11.472"
          y2="5.169"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="65.849"
          x2="91.279"
          y1="46.439"
          y2="78.841"
        >
          <stop stopColor="#0E0077" />
          <stop offset="1" stopColor="#0E0077" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="83.906"
          x2="46.007"
          y1="70.6"
          y2="67.231"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.995" stopColor="#586AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function ReviewsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[105px] w-[93px]", className)}
      fill="none"
      viewBox="0 0 93 105"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M91.308 78.978l.54-3.787-9.429-2.07-49.87-29.65a.945.945 0 00-.676-.125c-5.575 1.135-18.771 8.044-26.448 12.862l-4.467-.98.06 4.125c-.18.41-.024.93.414 1.197l58.326 35.618a.99.99 0 00.769.12c11.13-2.926 24.198-11.829 30.407-16.542a.943.943 0 00.374-.768z"
        fill={`url(#${id}-a)`}
        fillRule="evenodd"
      />
      <path
        d="M32.081 38.358c-6.868 1.457-25.216 11.908-30.8 16.345-.505.4-.418 1.173.144 1.526l58.678 36.94a.99.99 0 00.789.125C72.117 90.23 85.3 80.922 91.518 76.034c.537-.422.463-1.26-.136-1.626L32.772 38.49a.937.937 0 00-.69-.132z"
        fill={`url(#${id}-b)`}
      />
      <path
        d="M36.082 41.91L6.809 57.956l52.1 31.907 29.27-15.697L36.082 41.91z"
        fill="#fff"
        opacity="0.5"
      />
      <path
        d="M24.45 61.705l19.461-9.288a5 5 0 014.73.227l29.555 17.765c1.362.819 1.272 2.822-.158 3.514l-19.135 9.274a5 5 0 01-4.736-.202L24.288 65.229c-1.373-.817-1.281-2.835.161-3.524z"
        fill={`url(#${id}-c)`}
        opacity="0.33"
      />
      <path
        d="M23.95 43.576l-6.357 3.699c-.331.193-.292.688.068.847a.943.943 0 00.862-.046l6.3-3.73c.332-.197.273-.699-.098-.834a.916.916 0 00-.775.064zm55.316 37.235L72.91 84.51c-.332.193-.292.688.068.847a.943.943 0 00.862-.046l6.3-3.73c.331-.196.272-.698-.098-.834a.915.915 0 00-.776.064z"
        fill="#fff"
      />
      <ellipse
        fill="#fff"
        rx="0.961"
        ry="0.502"
        transform="matrix(.99923 .03926 -.0082 .99997 15.823 49.086)"
      />
      <path
        d="M30.76 33.137c-.062-.377-.102-.758-.058-1.123.498-4.16 6.15-6.195 8.921-4.644l34.06 19.107c2.891 1.619 5.235 5.618 5.235 8.931v14c0 3.314-4.39 7.398-7.281 5.78L33.548 50 30.76 33.137z"
        fill={`url(#${id}-d)`}
      />
      <path
        d="M60.593 64.096l-8.696 5.408a1.836 1.836 0 01-1.042.263l-2.771-.085c-.464-.015-1.012-.583-1.186-1.23l-4.666-17.315c-.222-.825.278-1.268.924-.818L60.07 62.114c.716.5 1.025 1.67.522 1.982z"
        fill="#96CDEF"
      />
      <path
        d="M34.949 30.509c-2.891-1.62-5.235-.246-5.235 3.068v15c0 2.761 1.953 6.094 4.362 7.443l9.463 5.3 3.224 7.472c.306.709.968 1.152 1.357.91l4.922-3.06 16.807 9.411c2.89 1.62 5.235.246 5.235-3.068v-14c0-3.314-2.344-7.312-5.235-8.932l-34.9-19.544z"
        fill={`url(#${id}-e)`}
      />
      <rect
        fill="#fff"
        height="14"
        rx="2.697"
        transform="matrix(.8725 .48862 0 1 35.82 36.997)"
        width="15"
      />
      <path
        d="M54.144 51.259l9.597 5.375"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.023"
      />
      <path
        d="M54.143 57.259l13.087 7.33"
        opacity="0.5"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.023"
      />
      <path
        d="M62.773 7.313C65.1 5.12 70.73 5.065 74.593 13.23c2.532 5.35-.859 10.817-5.865 13.63-1.843 1.035-6.642 1.85-8.828 1.85l.456-3.457C52.938 17.36 45.252 5.965 48.755 2.017c.844-.952 3.972-1.873 4.932-1.989 3.433-.412 7.268 3.777 9.086 7.285z"
        fill="#FF8E3D"
      />
      <path
        d="M58.86 9.373c2.326-2.195 7.956-2.248 11.82 5.917 3.877 8.194-3.78 14.578-11.76 14.482v.057l-.06-.058-.06-.001v-.058c-7.981-7.774-15.639-21.71-11.761-26.08 3.863-4.355 9.493 1.251 11.82 5.741z"
        fill={`url(#${id}-f)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-a`}
          x1="219.846"
          x2="160.557"
          y1="94.817"
          y2="-30.568"
        >
          <stop stopColor="#CEA8FF" />
          <stop offset="1" stopColor="#8F5DE0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="280.201"
          x2="235.188"
          y1="40.359"
          y2="-64.776"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-c`}
          x1="48.941"
          x2="80.913"
          y1="64.034"
          y2="102.189"
        >
          <stop stopColor="#0E0077" />
          <stop offset="1" stopColor="#0E0077" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-d`}
          x1="77.896"
          x2="30.582"
          y1="54.621"
          y2="32.236"
        >
          <stop stopColor="#B1DEF9" />
          <stop offset="1" stopColor="#90D3FC" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="82.013"
          x2="28.087"
          y1="93.997"
          y2="86.62"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.995" stopColor="#586AFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="71.719"
          x2="32.317"
          y1="40.778"
          y2="27.31"
        >
          <stop stopColor="#FF764A" />
          <stop offset="1" stopColor="#FF1A18" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function RoomsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[99px] w-[134px]", className)}
      fill="none"
      viewBox="0 0 134 99"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.056 68.48v-2.418l81.198-26.638 47.141 27.431v2.36L50.197 98.271l-47.14-29.79z"
        fill={`url(#${id}-a)`}
      />
      <mask
        height="60"
        id={`${id}-c`}
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="129"
        x="3"
        y="36"
      >
        <path
          d="M0 0h83.933v59.637H0z"
          fill={`url(#${id}-b)`}
          transform="matrix(.96742 -.34619 .79046 .49954 3 66.043)"
        />
      </mask>
      <g mask={`url(#${id}-c)`}>
        <path
          d="M0 0h83.933v59.637H0z"
          fill={`url(#${id}-d)`}
          transform="matrix(.96742 -.34619 .79046 .49954 3 66.043)"
        />
        <path
          clipRule="evenodd"
          d="M31.636 84.14l-2.473-1.564 16.525-11.762-30.399-4.548a1.354 1.354 0 01.4-2.678l33.176 4.964 14.577-10.376a1.354 1.354 0 011.57 2.205l-12.29 8.748 21.416 3.204 6.95-9.734-20.57-10.204a1.354 1.354 0 01-1.59-.79l-6.531-3.239 3.539-1.266 4.41 2.187 10.151-7.398 5.994-2.145c.164.537-.02 1.14-.498 1.49l-12.913 9.41 20.376 10.108 39.407.67 4.401 2.78-43.458-.75-6.663 9.33 25.973 3.886c.115.017.224.048.327.092l-5.31 1.9-22.755-3.404-11.075 15.51-4.461 1.596c.018-.03.037-.06.058-.088l5.363-7.511-24.848-6.873-8.78 6.25zm17.91-12.75l22.826 3.416-5.434 7.611-23.68-6.55 6.287-4.476z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
        />
        <path
          d="M99.216 57.692c-.304-6.064-10.762-10.935-23.62-10.935-12.81 0-23.238 4.836-23.614 10.87a3.055 3.055 0 01-.011-.269v8.178l.01.017c.355 6.041 10.792 10.887 23.615 10.887 7.636 0 14.426-1.718 18.745-4.384l1.342.693c.179 1.135.855 2.137 1.915 2.644.076.036.152.069.23.099l.58.279.062.061 17.386 8.855c.284.31.627.571 1.026.761 1.779.85 3.965-.02 4.884-1.944.882-1.848.272-3.996-1.356-4.915l.015-.028-12.118-6.166-6.841-3.642a3.315 3.315 0 00-.543-.325 3.411 3.411 0 00-2.595-.13c.582-.975.894-2.002.894-3.065v-7.572l-.006.031z"
          fill={`url(#${id}-e)`}
          opacity="0.3"
        />
      </g>
      <path
        d="M109.267 68.06c.058 1.12-2.315 2.154-5.302 2.31-2.986.154-5.454-.628-5.512-1.748-.058-1.12 2.315-2.153 5.302-2.308 2.986-.155 5.454.627 5.512 1.747zm-60.336-7.864c.058 1.12-2.315 2.153-5.302 2.308-2.986.155-5.454-.627-5.512-1.747-.058-1.12 2.316-2.153 5.302-2.308 2.986-.155 5.454.627 5.512 1.747zm6.811 26.182c.058 1.12-2.316 2.153-5.302 2.309-2.986.155-5.454-.627-5.512-1.747-.059-1.12 2.315-2.154 5.301-2.309 2.987-.155 5.455.627 5.513 1.747z"
        fill="#fff"
        opacity="0.23"
      />
      <path
        clipRule="evenodd"
        d="M99.252 52.462c0 6.19-10.577 11.207-23.625 11.207-12.823 0-23.26-4.845-23.617-10.887l-.009-.017v-8.178c0 1.083.54 2.34 1.769 3.613.368-.424.79-.836 1.26-1.232-2.423-8.136 11.757-12.074 20.597-12.074 8.84 0 22.11 2.727 20.597 12.074.46.388.873.79 1.236 1.204 1.033-1.242 1.618-2.41 1.793-3.282v7.572zm-4.031-2.113c-1.847-4.151-9.918-7.276-19.594-7.276-9.483 0-17.424 3.001-19.476 7.028 3.447 2.197 9.264 4.187 18.264 5.087C84.6 56.207 91.35 53.452 95.221 50.35z"
        fill={`url(#${id}-f)`}
        fillRule="evenodd"
      />
      <ellipse
        cx="75.627"
        cy="47.313"
        fill="#E0E0E0"
        fillOpacity="0.7"
        rx="19.991"
        ry="9.087"
      />
      <path
        d="M72.36 42.512c2.525-.474 7.874-1.058 12.752.676m3.907 2.05a14.141 14.141 0 00-1.818-1.139"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1.817"
      />
      <path
        clipRule="evenodd"
        d="M75.627 56.4c13.048 0 23.625-5.017 23.625-11.207S88.675 33.986 75.627 33.986 52 39.004 52 45.193c0 6.19 10.578 11.208 23.626 11.208zm0-2.423c11.04 0 19.99-4.068 19.99-9.086 0-5.019-8.95-9.087-19.99-9.087-11.041 0-19.991 4.068-19.991 9.087 0 5.018 8.95 9.086 19.99 9.086z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M94.7 54.178l.005-.009 12.738 6.582-2.174 4.206-12.449-6.432a2.368 2.368 0 111.88-4.347z"
        fill="#C2CBEC"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M97.856 62.721a3.38 3.38 0 01-.228-.099c-1.78-.85-2.477-3.097-1.558-5.02.918-1.923 3.105-2.794 4.884-1.944.194.092.375.202.543.326l18.719 9.966-3.635 5.755-18.725-8.984z"
        fill="#586BFF"
        fillRule="evenodd"
      />
      <path
        d="M98.5 63.062c-1.088-1.069-1.403-2.836-.66-4.392.919-1.923 3.105-2.794 4.884-1.944.184.088.356.19.516.306l17.215 8.758-3.458 6.692-18.497-9.42z"
        fill={`url(#${id}-g)`}
      />
      <path
        d="M120.386 65.925l-3.389 6.557-3.623-1.845c-.865-1.08-1.066-2.674-.389-4.092.918-1.923 3.105-2.794 4.884-1.944.184.088.356.19.516.306l2.001 1.018z"
        fill="#586BFF"
      />
      <ellipse
        cx="118.575"
        cy="69.195"
        fill="#fff"
        rx="3.57"
        ry="3.859"
        transform="rotate(25.526 118.575 69.195)"
      />
      <ellipse
        cx="118.576"
        cy="69.195"
        fill="#586BFF"
        rx="2.305"
        ry="2.492"
        transform="rotate(25.526 118.576 69.195)"
      />
      <path
        clipRule="evenodd"
        d="M41.088 33.646c0-5.34-3.752-11.833-8.37-14.503-2.501-1.446-4.77-1.473-6.323-.346l-3.987 2.572c.454.135 1.152.41 2.025.846a9.476 9.476 0 00-.157 1.762c0 .5-.01 1.012-.022 1.535-.053 2.417-.11 5.057.906 7.674 2.087 5.373 6.037 10.43 7.181 11.895.163.208-.505 1.004-.47 1.057.775-.542 9.217-5.378 9.217-12.492zm-11.796-8.304c-.3.45-.47 1.063-.47 1.81 0 2.453 1.732 5.411 3.824 6.638.634.371 1.234.538 1.764.523-.024-2.488-.665-4.932-2.468-6.666a34.924 34.924 0 00-2.65-2.305z"
        fill={`url(#h${id}-h)`}
        fillRule="evenodd"
      />
      <path
        d="M28.831 21.665c4.618 2.67 8.37 9.163 8.37 14.502 0 8.297-8.009 11.689-8.442 11.833-.433-.65-8.37-13.276-8.37-21.501 0-5.34 3.825-7.504 8.442-4.834zm-.072 14.647c2.093 1.226 3.824.216 3.824-2.165 0-2.381-1.731-5.411-3.824-6.638-2.092-1.227-3.824-.216-3.824 2.165 0 2.453 1.732 5.41 3.824 6.638z"
        fill={`url(#${id}-i)`}
      />
      <path
        clipRule="evenodd"
        d="M106.089 15.646c0-5.34-3.752-11.833-8.37-14.503C95.218-.303 92.95-.33 91.396.796L87.409 3.37c.454.135 1.152.41 2.025.846a9.476 9.476 0 00-.156 1.762c0 .5-.012 1.012-.023 1.535-.052 2.417-.11 5.057.906 7.674 2.087 5.373 6.037 10.43 7.181 11.895.163.208-.505 1.004-.47 1.057.775-.542 9.217-5.378 9.217-12.492zM94.293 7.342c-.3.45-.47 1.063-.47 1.81 0 2.453 1.732 5.411 3.824 6.638.634.372 1.234.538 1.764.523-.024-2.488-.665-4.932-2.468-6.666a34.926 34.926 0 00-2.65-2.305z"
        fill="#FFE6AD"
        fillRule="evenodd"
      />
      <path
        d="M93.832 3.665c4.618 2.67 8.37 9.163 8.37 14.502 0 8.297-8.009 11.689-8.442 11.833-.433-.65-8.37-13.276-8.37-21.501 0-5.34 3.825-7.504 8.442-4.834zM93.76 18.31c2.093 1.227 3.824.217 3.824-2.164 0-2.381-1.731-5.411-3.824-6.638-2.092-1.226-3.824-.216-3.824 2.165 0 2.453 1.732 5.41 3.824 6.637z"
        fill={`url(#${id}-j)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-a`}
          x1="128.066"
          x2="9.179"
          y1="63.626"
          y2="92.323"
        >
          <stop stopColor="#CEA8FF" />
          <stop offset="1" stopColor="#8F5DE0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="102.758"
          x2="37.363"
          y1="-8.18"
          y2="-54.301"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-d`}
          x1="102.758"
          x2="37.363"
          y1="-8.18"
          y2="-54.301"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="84.42"
          x2="122.17"
          y1="61.811"
          y2="106.327"
        >
          <stop stopColor="#0E0077" />
          <stop offset="1" stopColor="#0E0077" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="87.592"
          x2="45.819"
          y1="80.972"
          y2="65.836"
        >
          <stop stopColor="#586AFF" />
          <stop offset="1" stopColor="#43C9FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-g`}
          x1="120.455"
          x2="89.662"
          y1="78.823"
          y2="62.556"
        >
          <stop stopColor="#C1348C" />
          <stop offset="1" stopColor="#9432A4" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-h`}
          x1="39.108"
          x2="16.816"
          y1="52.347"
          y2="47.304"
        >
          <stop stopColor="#E27CBC" />
          <stop offset="1" stopColor="#D494DE" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-i`}
          x1="37.201"
          x2="9.832"
          y1="58.834"
          y2="52.655"
        >
          <stop stopColor="#C1348C" />
          <stop offset="1" stopColor="#9432A4" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-j`}
          x1="85.959"
          x2="103.417"
          y1="16.408"
          y2="17.926"
        >
          <stop stopColor="#C06B12" />
          <stop offset="1" stopColor="#F7B214" />
        </linearGradient>
      </defs>
    </svg>
  );
}
